import { createContext } from "react";

const domain = window.location.hostname.substring(0, window.location.hostname.indexOf("."));

const DomainContext = createContext(domain);

export default DomainContext;
